import React from 'react';
import Icon1 from '../../assets/images/icon1.svg';
import Icon2 from '../../assets/images/icon2.svg';
import Icon3 from '../../assets/images/icon3.svg';
import Icon4 from '../../assets/images/icon4.svg';
import Icon5 from '../../assets/images/icon5.png';
import Icon6 from '../../assets/images/icon6.png';
import Icon7 from '../../assets/images/icon7.png';
import Icon8 from '../../assets/images/icon8.png';
import PageBanner from "../../components/sections/front/PageBanner";
import WhoWeAre from "../../components/sections/front/WhoWeAre";
import OurVission from "../../components/sections/front/OurVission";
import TheTrihurst from "../../components/sections/front/TheTrihurst";
import OurTeam from "../../components/sections/front/OurTeam"; 
import CareerSection from "../../components/sections/front/Career";

const About = () => {
  const Banner = {
    title: "Our Story",
    description: "From humble beginnings to where we are today, our journey has been shaped by passion, innovation, and a commitment to excellence.",
  };
  const WhoWeAreDetails = {
    SubTitle: "Company Overview",
    title: "Who We Are",
    description: "Trihurst Tech is a global fintech company creating innovative solutions that bridge the gap between digital assets and today’s financial systems.<br/><br/> Our mission is to simplify and secure the way individuals and businesses interact <br/><br/> with digital currencies, making financial access more seamless, compliant, and user-friendly.<br/><br/> Headquartered across the UK, US, Ireland, and Poland, our team of 160+ <br/><br/> professionals brings together global expertise and a shared passion for financial innovation.",
  };
  const OurVissionDetails = {
    title: "OUR VISION",
    heading: "Crafting a Smarter Economy",
    description: "At Trihurst Tech, our values are the foundation of everything we build. From ethical innovation to transparency, we focus on creating solutions that drive meaningful progress in the digital economy.",
    items: [
      {
        icon: Icon1,
        title: "Integrity First",
        description: "We act with honesty, responsibility, and ethics in every solution we deliver to the world."
      },
      {
        icon: Icon2,
        title: "Innovation with Purpose",
        description: "We build technology that solves real problems and moves finance forward."
      },
      {
        icon: Icon3,
        title: "Transparency Always",
        description: "We believe clarity builds trust—in every product, process, and partnership."
      },
      {
        icon: Icon4,
        title: "Empowering Through Technology",
        description: "Our tools help businesses and users access modern finance with ease and security."
      }
    ]
  };
  const OurBeliefSystemDetails = {
    title: "TRIHURST TECH",
    items: [
      {
        image: Icon5,
        title: "Bitcoin",
        sub: "BTC/USD",
        value: "2.11%",
        trendIcon: "fa-regular fa-arrow-up",
        bgClass: "bg-coin1"
      },
      {
        image: Icon6,
        title: "Ethereum",
        sub: "ETH/USD",
        value: "1.90%",
        trendIcon: "fa-regular fa-arrow-up",
        bgClass: "bg-gradient-to-b from-[#8CA6F9] to-[#5472CE]"
      },
      {
        image: Icon7,
        title: "Litecoin",
        sub: "LTC/USD",
        value: "3.56%",
        trendIcon: "fa-regular fa-arrow-up",
        bgClass: "bg-gradient-to-b from-[#3C73FF] to-[#1C3678]"
      },
      {
        image: Icon8,
        title: "Ripple",
        sub: "XRP/USD",
        value: "0.23%",
        trendIcon: "fa-regular fa-arrow-up",
        bgClass: "bg-gradient-to-b from-[#00C6FF] to-[#0072FF]"
      },
      {
        image: Icon5,
        title: "Bitcoin",
        sub: "BTC/USD",
        value: "2.50%",
        trendIcon: "fa-regular fa-arrow-up",
        bgClass: "bg-coin1"
      }
    ]
  };

  const CareerDetails = {
    SubTitle: "Careers",
    title: "Empower Your Professional Growth",  
  }

  return (
    <>
      <PageBanner data={Banner} />
      <WhoWeAre data={WhoWeAreDetails} />
      <OurVission data={OurVissionDetails} />
      <TheTrihurst data={OurBeliefSystemDetails} />
      <OurTeam />
      <CareerSection data={CareerDetails}/>
    </>
  )
}

export default About;